<template lang="pug">
v-col(cols="12")
  v-hover(v-slot="{ hover }" v-if="isImage")
    v-card.relative(:href="value.file_name" target="_blank" flat outlined).overflow-hidden
      v-img(:src="value.file_name" height="380" cover)
      v-overlay(:value="hover" absolute ).text-center
        v-icon(size="64") mdi-image
        div Посмотреть полностью
  v-list-item(link v-else :href="value.file_name" target="_blank").ma-4
    v-list-item-action
      v-avatar(size="64" color="secondary")
        v-icon(size="38" color="white") mdi-file-document-outline
    v-list-item-content
      v-list-item-title: strong {{ fileName }}
    //- v-btn.mt-4(color="secondary" small block :href="value.file_name" target="_blank") Подробнее
    //- a(:href="value.file_name") {{ value.file_name }}

</template>

<script>
const IMAGE_TYPES = ['jpg', 'png', 'svg'];

export default {
  name: 'TypeFile',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fileName() {
      const result = this.value.file_name.split('/');
      return result[result.length - 1];
    },
    fileType() {
      return this.fileName.split('.')[1];
    },
    isImage() {
      return IMAGE_TYPES.includes(this.fileType);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
